export default [
  {
    path: '/database-columns/:databaseConfigId/:databaseName/:tableName',
    name: 'DatabaseColumns',
    component: () => import("@/views/Page/DatabaseColumns/DatabaseColumns.vue"),
    meta: {
      title: '#Default# | Database Columns',
    },
  }
];
